import React from "react";
import { createPortal } from "react-dom";
import "./CvDownloadModal.css";

const CV_OPTIONS = [
  {
    label: "French",
    href: "/CV_2026-02-10_AIT-SIDI-SAID_HAMZA.pdf",
    fileName: "CV_2026-02-10_AIT-SIDI-SAID_HAMZA.pdf"
  },
  {
    label: "English",
    href: "/CV_2026-06-10_AIT-SIDI-SAID_HAMZA_EN.pdf",
    fileName: "CV_2026-06-10_AIT-SIDI-SAID_HAMZA_EN.pdf"
  }
];

export default function CvDownloadModal({ open, onClose }) {
  React.useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open || typeof document === "undefined") return null;

  const handleSelect = (href, fileName) => {
    const link = document.createElement("a");
    link.href = href;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    onClose();
  };

  return createPortal(
    <div className="cvModalBackdrop" role="presentation" onClick={onClose}>
      <div
        className="cvModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cv-modal-title"
        aria-describedby="cv-modal-desc"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="cvModalHeader">
          <p className="cvModalKicker">Download CV</p>
          <h2 id="cv-modal-title" className="cvModalTitle">
            Choose a language
          </h2>
          <p id="cv-modal-desc" className="cvModalDesc">
            Select the version that fits the role or recruiter context.
          </p>
        </div>

        <div className="cvModalActions">
          {CV_OPTIONS.map((option) => (
            <button
              key={option.label}
              type="button"
              className="cvModalBtn"
              onClick={() => handleSelect(option.href, option.fileName)}
            >
              <span>{option.label}</span>
              <small>{option.fileName}</small>
            </button>
          ))}
        </div>

        <button type="button" className="cvModalClose" onClick={onClose}>
          Close
        </button>
      </div>
    </div>,
    document.body
  );
}
